import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cm-key-val-list',
    templateUrl: './key-val-list.component.html',
    styleUrls: ['./key-val-list.component.scss'],
    standalone: false
})
export class CmKeyValListComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
